module.exports = __webpack_public_path__ + "img/13-CSA.abfe5f6b.jpg";